import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { trackPageView } from "@/lib/metaPixel";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChairConsole from "@/pages/ChairConsole";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Portal from "@/pages/Portal";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import SupportFab from "@/components/SupportFab";

function AppRoutes() {
  const location = useLocation();
  // Fire a Meta Pixel PageView on every client-side navigation.
  // The base pixel already fires the initial PageView at hard load, so skip
  // the very first invocation to avoid double-counting.
  useEffect(() => {
    if (window.__mp_initial_skipped) {
      trackPageView();
    } else {
      window.__mp_initial_skipped = true;
    }
  }, [location.pathname]);

  // Synchronously detect Emergent OAuth callback hash before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/qa/chair" element={<ChairConsole />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <SupportFab />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
